<div class="ams-chatbot-message" [class.ams-chatbot-message--user]="message().role === 'user'">
  <div
    class="ams-chatbot-message__avatar"
    [class.ams-chatbot-message__avatar--assistant]="message().role === 'assistant'"
  >
    {{ message().role === 'assistant' ? 'AI' : 'You' }}
  </div>

  <div class="ams-chatbot-message__body">
    <div
      class="ams-chatbot-message__bubble"
      [class.ams-chatbot-message__bubble--user]="message().role === 'user'"
      [class.ams-chatbot-message__bubble--assistant]="message().role === 'assistant'"
      (dragstart)="$event.preventDefault()"
    >
      @if (message().isTyping) {
        <div class="ams-chatbot-message__typing">
          <span></span><span></span><span></span>
        </div>
      } @else if (message().role === 'user') {
        <span class="ams-chatbot-message__user-text">{{ message().content }}</span>
      } @else {
        <div class="ams-chatbot-message__markdown" [innerHTML]="htmlContent() | safeHtml"></div>

        @if (showCitations() && message().citations?.length) {
          <div class="ams-chatbot-message__citations">
            @for (citation of message().citations; track $index) {
              <div class="ams-chatbot-message__citation">
                <span class="ams-chatbot-message__citation-title">{{ citation.title }}</span>
                @if (citation.section) {
                  <span class="ams-chatbot-message__citation-meta">{{ citation.section }}</span>
                } @else if (citation.sourceFile) {
                  <span class="ams-chatbot-message__citation-meta">{{ citation.sourceFile }}</span>
                }
              </div>
            }
          </div>
        }

        @if (message().suggestions?.length) {
          <div class="ams-chatbot-message__actions-row">
            @for (suggestion of message().suggestions; track suggestion.label) {
              <button
                class="ams-chatbot-message__chip"
                type="button"
                (click)="sendSuggestion.emit(suggestion)"
              >
                {{ suggestion.label }}
              </button>
            }
          </div>
        }

        @if (message().slotFillGroups?.length) {
          <div class="ams-chatbot-message__slot-groups">
            @for (group of message().slotFillGroups; track group.fieldKey) {
              <div class="ams-chatbot-message__slot-group">
                <div class="ams-chatbot-message__slot-group-label">{{ group.label }}</div>
                <div class="ams-chatbot-message__slot-chips">
                  @for (option of group.options; track option.value) {
                    <button
                      class="ams-chatbot-message__chip ams-chatbot-message__chip--slot"
                      [class.ams-chatbot-message__chip--selected]="isChipSelected(group.fieldKey, option.value)"
                      type="button"
                      (click)="onSlotChipClick(group.fieldKey, option.value, group.selectMode)"
                    >
                      {{ option.label }}
                    </button>
                  }
                </div>
              </div>
            }
          </div>
        }

        @if (message().action && message().action?.canLaunch !== false && !message().actionDismissed) {
          <div class="ams-chatbot-message__launch">
            <button
              class="ams-chatbot-message__launch-primary"
              type="button"
              (click)="confirmAction.emit(message().id)"
            >
              {{ actionLabel() }}
            </button>
            <button
              class="ams-chatbot-message__launch-secondary"
              type="button"
              (click)="dismissAction.emit(message().id)"
            >
              Not now
            </button>
          </div>
        }

        @if (message().navigation?.length) {
          @if (navigationPrompt()) {
            <p class="ams-chatbot-message__nav-prompt">{{ navigationPrompt() }}</p>
          }
          <div class="ams-chatbot-message__actions-row">
            @for (navigation of message().navigation; track navigation.route) {
              <button
                class="ams-chatbot-message__chip ams-chatbot-message__chip--nav"
                type="button"
                (click)="navigateTo.emit(navigation)"
              >
                {{ navigation.label }}
              </button>
            }
          </div>
        }
      }
    </div>

    @if (!message().isTyping) {
      <div class="ams-chatbot-message__time">{{ formatTime(message().timestamp) }}</div>
    }
  </div>
</div>
